import moment from "moment";

const CancelledChefitBanner = ({ record }: { record: any }) => {
  if (record?.status !== "CANCELLED") return null;

  return (
    <div
      style={{
        backgroundColor: "#FEF2F2",
        border: "1px solid #FECACA",
        borderRadius: "8px",
        padding: "10px 14px",
        marginBottom: "10px",
        display: "flex",
        gap: "10px",
        alignItems: "flex-start",
      }}
    >
      {/* Icon */}
      <div
        style={{
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          backgroundColor: "#FEE2E2",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#DC2626",
          fontWeight: 700,
          fontSize: "15px",
          flexShrink: 0,
          marginTop: "1px",
        }}
      >
        ✕
      </div>

      {/* Content */}
      <div style={{ flex: 1 }}>
        {/* Line 1: title + key fields inline */}
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", alignItems: "center", fontSize: "13px" }}>
          <span style={{ fontSize: "14px", fontWeight: 600, color: "#991B1B" }}>
            Chefit Cancelled
          </span>

          {record?.cancelledAt && (
            <div>
              <span style={{ color: "#7F1D1D", fontWeight: 500 }}>Cancelled At:</span>{" "}
              <span style={{ color: "#991B1B" }}>{moment(record.cancelledAt).format("DD/MM/YYYY hh:mm A")}</span>
            </div>
          )}

          {(record?.cancellationReason || record?.cancellationSubReason) && (
            <div>
              <span style={{ color: "#7F1D1D", fontWeight: 500 }}>Reason:</span>{" "}
              <span style={{ color: "#991B1B" }}>{record?.cancellationReason || record?.cancellationSubReason}</span>
            </div>
          )}

          {record?.cancelledBy && (
            <div>
              <span style={{ color: "#7F1D1D", fontWeight: 500 }}>Cancelled By:</span>{" "}
              <span style={{ color: "#991B1B" }}>{record.cancelledBy}</span>
            </div>
          )}

          {record?.cancelledByEmail && (
            <div>
              <span style={{ color: "#7F1D1D", fontWeight: 500 }}>Email:</span>{" "}
              <span style={{ color: "#991B1B" }}>{record.cancelledByEmail}</span>
            </div>
          )}
        </div>

        {/* Line 2: sub reason, refund, last minute — only if any exist */}
        {(record?.cancellationSubReason && record?.cancellationReason) || record?.refundMessage || record?.lastMinuteCancellationMessage ? (
          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", alignItems: "center", fontSize: "13px", marginTop: "5px", paddingTop: "5px", borderTop: "1px solid #FECACA" }}>
            {record?.cancellationSubReason && record?.cancellationReason && (
              <div>
                <span style={{ color: "#7F1D1D", fontWeight: 500 }}>Sub Reason:</span>{" "}
                <span style={{ color: "#991B1B" }}>{record.cancellationSubReason}</span>
              </div>
            )}
            {record?.refundMessage && (
              <span style={{ color: "#991B1B" }}>{record.refundMessage}</span>
            )}
            {record?.lastMinuteCancellationMessage && (
              <span style={{ color: "#991B1B" }}>{record.lastMinuteCancellationMessage}</span>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CancelledChefitBanner;
